<form class="consignment-form py-4 px-0 px-sm-3 px-md-5 w-100 row position-relative">
    <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" (click)="dialogRef.close()"></i>
    <h4 class="col-12 mt-3 mb-5 text-bold text-center">
        {{isCreation ? 'Creación de Remesa' : 'Edición de Remesa'}}
        <span class="color-secondary-dark" *ngIf="!isCreation">{{consignmentId}}</span>
    </h4>
    <div class="col-12 alert alert-info text-center pt-4 pb-3 mt-3"
        *ngIf="documentRecreationInProgress" role="status">
        <i class="fas fa-sync-alt fa-spin mr-2"></i>
        {{documentRecreationInProgressMessage}}
    </div>
    <app-consignment-card class="col-12" [form]="consignmentForm"
        [title]="isCreation ? 'Nueva Remesa' : 'Remesa ' + (consignmentId)" [formValidate]="formValidate"
        [senderCityOptions]="senderCityOptions" *ngIf="consignmentForm" [recipientCityOptions]="recipientCityOptions"
        [canDeleteConsignment]="false" [cargo]="cargo">
    </app-consignment-card>
    <div class="col-12 consignment-form__map" *ngIf="consignmentForm">
        <app-standard-map #standardMap [options]="mapOptions" (mapReady)="onMapReady()"></app-standard-map>
    </div>
    <!-- Submit button -->
    <div class="button-container my-3  col-12">
        <button type="button" mat-raised-button color="primary" class="primary-secondary bg-color-primary"
            (click)="dialogRef.close()">Cancelar</button>
        <button mat-raised-button color="primary" type="button" (click)="onSubmit()"
            [disabled]="documentRecreationInProgress"
            class="bg-color-primary">Guardar</button>
    </div>
</form>
